import { filterItemsBySearchTerm, sortItems } from './helper';

export const getFilteredItemsFromClient = (
    searchTerm,
    items,
    selectedItems,
    primaryKey,
    secondaryKey
) => {
    const searchLowerCase = searchTerm.toLowerCase();

    return items
        .filter((item) =>
            filterItemsBySearchTerm(
                item,
                searchLowerCase,
                primaryKey,
                secondaryKey
            )
        )
        .sort((a, b) => sortItems(a, b, searchLowerCase, selectedItems, items));
};

